import React from 'react';

import { Heading } from '@eluve/components';
import { reviewOfSystemsSchema } from '@eluve/llm-outputs';

import { OutputParsingError } from './OutputParsingError';

export interface ReviewOfSystemsOutputProps {
  content: unknown;
}

export const ReviewOfSystemsOutput: React.FC<ReviewOfSystemsOutputProps> = ({
  content,
}) => {
  const ros = reviewOfSystemsSchema.safeParse(content);

  if (!ros.success) {
    return <OutputParsingError />;
  }

  return (
    <div className="space-y-4">
      {ros.data.map((item) => (
        <div key={item.name}>
          <Heading size="xl" weight="semibold" className="my-1">
            {item.name}
          </Heading>
          {item.justification && (
            <div className="italic">{item.justification}</div>
          )}
        </div>
      ))}
    </div>
  );
};
